import React, { useState } from "react"

const invalidInput = 'is-invalid'
const validInput = 'is-valid'
const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^+=*]).*$/

const PasswordInput = ({ value, onChange }) => {
  const handleChange = (event) => {
    const password = event.target.value
    const isValid = validate(password)
    if (onChange) {
      onChange(password, isValid)
    }
  }

  const [validityClass, setValidityClass] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const validate = (value) => {
    let isValid = true
    if (!value) {
      setErrorMessage('Required');
      isValid = false;
    } else if (value.length > 50) {
      setErrorMessage('Max 50 characters');
      isValid = false;
    } else if (value.length < 8) {
      setErrorMessage('Min 8 characters');
      isValid = false;
    } else if (!passwordRegex.test(value)) {
      setErrorMessage('At least one upper and lower case letter, digit and special character (!@#$%^+=*) required');
      isValid = false;
    }

    if (isValid) {
      setValidityClass(validInput)
    } else {
      setValidityClass(invalidInput)
    }
    return isValid
  }

  return(
    <React.Fragment>
      <div className="form-group">
        <label htmlFor="password">Password</label>
        <input id="password" 
                type="password" 
                name="password" 
                className={`form-control ${validityClass}`}
                onChange={ handleChange } 
                required 
                value={ value } 
                maxLength="50" 
                aria-describedby="password-validation-message"
                data-testid="edit-user-password"/>
      </div>
      { validityClass === invalidInput &&
        <div id="password-validation-message" 
            className="invalid-feedback"
            style={{ 
              display: 'block',
              marginLeft: '230px'
                    }}>
          { errorMessage }
        </div>     
      }
    </React.Fragment>
  )
}

export default PasswordInput